import { Box, Typography, useTheme } from '@mui/material';
import { tokens } from '../../../../global/theme/tokens';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import ExoAvatar from '../../ExoAvatar';
import { renderHours } from '../../../../scenes/time-tracking/worktime';
import { useMethodColor } from '../time-functions/useMethodColors';

const TimeBox = ({
  time,
  selected,
  marginLeft,
  dateToPixel,
  onClick,
  edit,
  mobileView,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();
  const startMoment = moment(time.timeStart);
  const endMoment = moment(time.timeEnd);
  const timeInMinutes = endMoment.diff(startMoment, 'minutes');

  // color
  const colorToUse = useMethodColor(time.method);

  const top = dateToPixel(time.timeStart);
  const height = Math.abs(dateToPixel(time.timeEnd) - top);

  const padding = mobileView ? 2 : 10;

  const heightThreshold = 80;

  const project = time.project || { client: {}, name: t('Deleted') };

  if (time.method === 'delete') return;
  return (
    <Box
      className="absolute px-2 w-full cursor-pointer"
      onMouseDown={(e) => e.preventDefault()}
      onClick={() => onClick(time)}
      style={{
        display: selected ? 'none' : 'flex',
        top: `${top}px`,
        height: `${height}px`,
        width: '100%',
        zIndex: 1,
        paddingLeft: `${marginLeft + padding}px`,
        paddingRight: `${padding}px`,
      }}
    >
      <Box
        className="relative  h-full w-full rounded-lg flex flex-col backdrop-blur-sm items-center"
        onMouseDown={(e) => e.preventDefault()}
        sx={{
          bgcolor: colorToUse.primary,
          borderWidth: '1px',
          borderColor: colorToUse.secondary,
          justifyContent: height > 100 || height < 40 ? 'center' : 'start',
          padding: height > 100 ? '0px 4px' : '8px 0px',
        }}
      >
        {time.workPackage?.icon?.temporaryUrl ? (
          <img
            src={time.workPackage.icon.temporaryUrl}
            className="h-[30px] w-[30px] rounded-[5px] object-cover"
            alt="Work Package Icon"
          />
        ) : project.image ? (
          <img
            src={project.image.temporaryUrl}
            className="h-[30px] w-[30px] rounded-[5px] object-cover"
            alt="Project Image"
          />
        ) : (
          <ExoAvatar
            picture={project.client?.logo?.temporaryUrl}
            size={height < 30 ? height : 30}
            type={project.clientType ?? 'company'}
          />
        )}

        {!mobileView && height > heightThreshold && (
          <>
            {project ? (
              <>
                <Typography variant="h5" textAlign="center">
                  {time.workPackage?.title}
                </Typography>
                <Typography
                  variant="body2"
                  textAlign="center"
                  color="text.secondary"
                >
                  {project?.name || project?.label}
                </Typography>
              </>
            ) : (
              <Typography variant="h5" textAlign="center">
                {t('INTERNAL')}
              </Typography>
            )}
          </>
        )}
        {!mobileView && height > 21 && (
          <Typography
            variant="h5"
            textAlign="center"
            className="monospace absolute right-1"
            sx={{
              bottom: `${height < 29 ? (height - 21) / 2 : 4}px`,
            }}
          >
            {renderHours(timeInMinutes)} h
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default TimeBox;
